// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Jotai from "jotai";
import * as React from "react";
import * as Caml_obj from "rescript/lib/es6/caml_obj.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";
import * as ReactFinalForm from "react-final-form";
import * as JsxPPXReactSupportU from "rescript/lib/es6/jsxPPXReactSupportU.js";
import * as Block$OrcaPaymentPage from "./Block.bs.js";
import * as Utils$OrcaPaymentPage from "../Utilities/Utils.bs.js";
import * as RenderIf$OrcaPaymentPage from "./RenderIf.bs.js";
import * as Surcharge$OrcaPaymentPage from "./Surcharge.bs.js";
import * as JotaiAtoms$OrcaPaymentPage from "../Utilities/JotaiAtoms.bs.js";
import * as ConfirmType$OrcaPaymentPage from "../Types/ConfirmType.bs.js";
import * as InfoElement$OrcaPaymentPage from "./InfoElement.bs.js";
import * as PaymentType$OrcaPaymentPage from "../Types/PaymentType.bs.js";
import * as PaymentUtils$OrcaPaymentPage from "../Utilities/PaymentUtils.bs.js";
import * as ReactFinalForm$OrcaPaymentPage from "../../shared-code/sdk-utils/components/ReactFinalForm.bs.js";
import * as DynamicFieldInput$OrcaPaymentPage from "./DynamicFieldInput.bs.js";
import * as DynamicFieldsUtils$OrcaPaymentPage from "../Utilities/DynamicFieldsUtils.bs.js";
import * as PaymentMethodsRecord$OrcaPaymentPage from "../Payments/PaymentMethodsRecord.bs.js";

function DynamicFields$DynamicFieldsToRenderWrapper(props) {
  var __isInside = props.isInside;
  var children = props.children;
  var isInside = __isInside !== undefined ? __isInside : true;
  var match = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.configAtom);
  return React.createElement(RenderIf$OrcaPaymentPage.make, {
              condition: Caml_obj.notequal(children, null),
              children: React.createElement("div", {
                    key: (
                      isInside ? "inside" : "outside"
                    ) + "-billing-" + props.index.toString(),
                    className: "flex flex-col w-full place-content-between",
                    style: {
                      gridColumnGap: isInside ? "0px" : match.themeObj.spacingGridRow
                    }
                  }, children)
            });
}

var DynamicFieldsToRenderWrapper = {
  make: DynamicFields$DynamicFieldsToRenderWrapper
};

function DynamicFields$FormBody(props) {
  var syncEmitAddressAtoms = props.syncEmitAddressAtoms;
  var setRequiredFieldsBody = props.setRequiredFieldsBody;
  var paymentMethodType = props.paymentMethodType;
  var allCardHolderNameFields = props.allCardHolderNameFields;
  var allEmailFields = props.allEmailFields;
  var dynamicFieldsInsideBilling = props.dynamicFieldsInsideBilling;
  var dynamicFieldsOutsideBilling = props.dynamicFieldsOutsideBilling;
  var missingRequiredFieldsFiltered = props.missingRequiredFieldsFiltered;
  var languagePreferenceFields = props.languagePreferenceFields;
  var formProps = props.formProps;
  var match = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.configAtom);
  var themeObj = match.themeObj;
  var config = match.config;
  var setAreRequiredFieldsValid = Jotai.useSetAtom(JotaiAtoms$OrcaPaymentPage.areRequiredFieldsValid);
  var setAreRequiredFieldsEmpty = Jotai.useSetAtom(JotaiAtoms$OrcaPaymentPage.areRequiredFieldsEmpty);
  var isSpacedInnerLayout = config.appearance.innerLayout === "Spaced";
  var isRenderDynamicFieldsInsideBilling = dynamicFieldsInsideBilling.length > 0;
  var spacedStylesForBillingDetails = isSpacedInnerLayout ? "p-2" : "my-2";
  props.formRef.current = formProps.form;
  ReactFinalForm$OrcaPaymentPage.useFormStateHandler((function (values) {
          var flatValues = Utils$OrcaPaymentPage.flattenObject(values, false);
          languagePreferenceFields.forEach(function (field) {
                flatValues[field.confirmRequestWritePath] = DynamicFieldsUtils$OrcaPaymentPage.getComputedLanguagePreferenceValue(config.locale, Core__Option.getOr(field.dropdownOptions, []));
              });
          setRequiredFieldsBody(function (param) {
                return flatValues;
              });
          syncEmitAddressAtoms(flatValues);
          var isEmpty = missingRequiredFieldsFiltered.some(function (field) {
                var match = flatValues[field.confirmRequestWritePath];
                if (match !== undefined && !(!Array.isArray(match) && (match === null || typeof match !== "object") && typeof match !== "number" && typeof match !== "string" && typeof match !== "boolean")) {
                  if (typeof match === "string") {
                    return match.trim() === "";
                  } else {
                    return false;
                  }
                } else {
                  return true;
                }
              });
          setAreRequiredFieldsEmpty(function (param) {
                return isEmpty;
              });
        }), (function (isValid) {
          setAreRequiredFieldsValid(function (param) {
                return isValid;
              });
        }), undefined, formProps);
  return React.createElement(React.Fragment, {}, DynamicFieldInput$OrcaPaymentPage.groupFieldsByRow(dynamicFieldsOutsideBilling).map(function (row, rowIdx) {
                  return JsxPPXReactSupportU.createElementWithKey("outside-row-" + rowIdx.toString(), DynamicFields$DynamicFieldsToRenderWrapper, {
                              children: React.createElement(DynamicFieldInput$OrcaPaymentPage.makeRow, {
                                    items: row,
                                    allFields: dynamicFieldsOutsideBilling,
                                    paymentMethodType: paymentMethodType,
                                    globalEmailFields: allEmailFields,
                                    globalCardHolderNameFields: allCardHolderNameFields
                                  }),
                              index: rowIdx,
                              isInside: false
                            });
                }), React.createElement(RenderIf$OrcaPaymentPage.make, {
                  condition: isRenderDynamicFieldsInsideBilling,
                  children: React.createElement("div", {
                        className: "billing-section " + spacedStylesForBillingDetails + " w-full text-left",
                        style: {
                          border: isSpacedInnerLayout ? "1px solid " + themeObj.borderColor : "",
                          borderRadius: isSpacedInnerLayout ? themeObj.borderRadius : ""
                        }
                      }, React.createElement("div", {
                            className: "billing-details-text",
                            style: {
                              fontSize: themeObj.fontSizeLg,
                              marginBottom: "5px",
                              opacity: "0.6"
                            }
                          }, match.localeString.billingDetailsText), React.createElement("div", {
                            className: "flex flex-col",
                            style: {
                              gap: isSpacedInnerLayout ? themeObj.spacingGridRow : ""
                            }
                          }, DynamicFieldInput$OrcaPaymentPage.groupFieldsByRow(dynamicFieldsInsideBilling).map(function (row, rowIdx) {
                                return JsxPPXReactSupportU.createElementWithKey("inside-row-" + rowIdx.toString(), DynamicFields$DynamicFieldsToRenderWrapper, {
                                            children: React.createElement(DynamicFieldInput$OrcaPaymentPage.makeRow, {
                                                  items: row,
                                                  allFields: dynamicFieldsInsideBilling,
                                                  paymentMethodType: paymentMethodType,
                                                  globalEmailFields: allEmailFields,
                                                  globalCardHolderNameFields: allCardHolderNameFields
                                                }),
                                            index: rowIdx
                                          });
                              })))
                }));
}

var FormBody = {
  make: DynamicFields$FormBody
};

function DynamicFields(props) {
  var __isDisableInfoElement = props.isDisableInfoElement;
  var __isSavedCardFlow = props.isSavedCardFlow;
  var setRequiredFieldsBody = props.setRequiredFieldsBody;
  var paymentMethodType = props.paymentMethodType;
  var paymentMethod = props.paymentMethod;
  var isSavedCardFlow = __isSavedCardFlow !== undefined ? __isSavedCardFlow : false;
  var isDisableInfoElement = __isDisableInfoElement !== undefined ? __isDisableInfoElement : false;
  var paymentMethodListValue = Jotai.useAtomValue(PaymentUtils$OrcaPaymentPage.paymentMethodListValue);
  var match = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.configAtom);
  var localeString = match.localeString;
  var match$1 = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.optionAtom);
  var billingAddress = match$1.billingAddress;
  var defaultValues = match$1.defaultValues;
  var syncEmitAddressAtoms = DynamicFieldsUtils$OrcaPaymentPage.useSyncEmitAddressAtoms();
  var intentData = paymentMethodListValue.intent_data.intentDataObject;
  var match$2 = DynamicFieldsUtils$OrcaPaymentPage.useSuperpositionRequiredFields(paymentMethod, paymentMethodType);
  var superpositionInitialValues = match$2[2];
  var missingRequiredFields = match$2[1];
  var requiredFields = match$2[0];
  var initialValues = React.useMemo((function () {
          return superpositionInitialValues;
        }), [
        intentData,
        paymentMethodType,
        billingAddress.isUseBillingAddress,
        billingAddress.usePrefilledValues
      ]);
  React.useEffect((function () {
          setRequiredFieldsBody(function (prev) {
                return DynamicFieldsUtils$OrcaPaymentPage.filterByActiveFields(prev, requiredFields);
              });
        }), [requiredFields]);
  var missingRequiredFieldsFiltered = React.useMemo((function () {
          var firstEmailPath = Core__Option.map(missingRequiredFields.filter(function (fieldConfig) {
                      return fieldConfig.fieldRenderType === "Email";
                    })[0], (function (fieldConfig) {
                  return fieldConfig.confirmRequestWritePath;
                }));
          var firstCardHolderNamePath = Core__Option.map(missingRequiredFields.filter(function (fieldConfig) {
                      return fieldConfig.fieldRenderType === "CardHolderName";
                    })[0], (function (fieldConfig) {
                  return fieldConfig.confirmRequestWritePath;
                }));
          return missingRequiredFields.filter(function (field) {
                      var match = field.fieldRenderType;
                      switch (match) {
                        case "Dropdown" :
                            var options = Core__Option.getOr(field.dropdownOptions, []);
                            return options.length > 0;
                        case "Email" :
                            return firstEmailPath === field.confirmRequestWritePath;
                        case "CardHolderName" :
                            return firstCardHolderNamePath === field.confirmRequestWritePath;
                        case "CardNumber" :
                        case "Cvc" :
                        case "CardExpiryMonth" :
                        case "CardExpiryYear" :
                        case "CardNetwork" :
                        case "LanguagePreference" :
                            return false;
                        default:
                          return true;
                      }
                    });
        }), [missingRequiredFields]);
  var initialValuesWithBillingDataOverride = React.useMemo((function () {
          return DynamicFieldsUtils$OrcaPaymentPage.applyBillingDetailsOverride(initialValues, defaultValues.billingDetails);
        }), [
        initialValues,
        defaultValues.billingDetails
      ]);
  var isInsideBillingField = function (field) {
    if (field.fieldRenderType === "Email") {
      return true;
    } else if (field.confirmRequestWritePath.startsWith(DynamicFieldsUtils$OrcaPaymentPage.billingPrefix)) {
      return !(paymentMethod === "card" && field.fieldRenderType === "CardHolderName");
    } else {
      return false;
    }
  };
  var dynamicFieldsInsideBilling = React.useMemo((function () {
          return missingRequiredFieldsFiltered.filter(function (field) {
                      return isInsideBillingField(field);
                    });
        }), [missingRequiredFieldsFiltered]);
  var dynamicFieldsOutsideBilling = React.useMemo((function () {
          return missingRequiredFieldsFiltered.filter(function (field) {
                      return !isInsideBillingField(field);
                    });
        }), [missingRequiredFieldsFiltered]);
  var allEmailFields = React.useMemo((function () {
          return missingRequiredFields.filter(function (fieldConfig) {
                      return fieldConfig.fieldRenderType === "Email";
                    });
        }), [missingRequiredFields]);
  var allCardHolderNameFields = React.useMemo((function () {
          return missingRequiredFields.filter(function (fieldConfig) {
                      return fieldConfig.fieldRenderType === "CardHolderName";
                    });
        }), [missingRequiredFields]);
  var languagePreferenceFields = React.useMemo((function () {
          return requiredFields.filter(function (fieldConfig) {
                      return fieldConfig.fieldRenderType === "LanguagePreference";
                    });
        }), [requiredFields]);
  var formRef = React.useRef(undefined);
  var submitCallback = React.useCallback((function (ev) {
          var json = Utils$OrcaPaymentPage.safeParse(ev.data);
          var confirm = ConfirmType$OrcaPaymentPage.itemToObjMapper(Utils$OrcaPaymentPage.getDictFromJson(json));
          if (confirm.doSubmit) {
            return Core__Option.forEach(formRef.current, (function (form) {
                          form.submit();
                        }));
          }
          
        }), [formRef]);
  Utils$OrcaPaymentPage.useSubmitPaymentData(submitCallback);
  var bottomElement = React.createElement(InfoElement$OrcaPaymentPage.make, {});
  var isInfoElementPresent = React.useMemo((function () {
          return Core__Option.getOr(Core__Option.map(PaymentMethodsRecord$OrcaPaymentPage.getPaymentMethodsFields(localeString).find(function (pm) {
                              return pm.paymentMethodName === paymentMethodType;
                            }), (function (pm) {
                            return pm.fields.includes("InfoElement");
                          })), false);
        }), [paymentMethodType]);
  var isRenderInfoElement = !isSavedCardFlow && isInfoElementPresent && !isDisableInfoElement && match$1.redirectionInfo === "ShowRedirectionInfo";
  var hasAnyField = missingRequiredFieldsFiltered.length > 0;
  var shouldRenderForm = hasAnyField || Object.keys(initialValuesWithBillingDataOverride).length > 0;
  var setAreRequiredFieldsValid = Jotai.useSetAtom(JotaiAtoms$OrcaPaymentPage.areRequiredFieldsValid);
  var setAreRequiredFieldsEmpty = Jotai.useSetAtom(JotaiAtoms$OrcaPaymentPage.areRequiredFieldsEmpty);
  React.useEffect((function () {
          if (isSavedCardFlow || !hasAnyField) {
            setAreRequiredFieldsValid(function (param) {
                  return true;
                });
            setAreRequiredFieldsEmpty(function (param) {
                  return false;
                });
          }
          
        }), [
        isSavedCardFlow,
        hasAnyField
      ]);
  React.useEffect((function () {
          if (!shouldRenderForm) {
            setRequiredFieldsBody(function (param) {
                  return {};
                });
          }
          
        }), [
        paymentMethodType,
        shouldRenderForm
      ]);
  DynamicFieldsUtils$OrcaPaymentPage.useLogDynamicFieldsRendered(missingRequiredFieldsFiltered, paymentMethod, match$2[3], isSavedCardFlow);
  return React.createElement(React.Fragment, {}, React.createElement(RenderIf$OrcaPaymentPage.make, {
                  condition: !isSavedCardFlow && shouldRenderForm,
                  children: React.createElement(ReactFinalForm.Form, {
                        onSubmit: (function (_values) {
                            
                          }),
                        initialValues: Caml_option.some(initialValuesWithBillingDataOverride),
                        render: (function (formProps) {
                            return React.createElement(DynamicFields$FormBody, {
                                        formProps: formProps,
                                        formRef: formRef,
                                        languagePreferenceFields: languagePreferenceFields,
                                        missingRequiredFieldsFiltered: missingRequiredFieldsFiltered,
                                        dynamicFieldsOutsideBilling: dynamicFieldsOutsideBilling,
                                        dynamicFieldsInsideBilling: dynamicFieldsInsideBilling,
                                        allEmailFields: allEmailFields,
                                        allCardHolderNameFields: allCardHolderNameFields,
                                        paymentMethodType: paymentMethodType,
                                        setRequiredFieldsBody: setRequiredFieldsBody,
                                        syncEmitAddressAtoms: syncEmitAddressAtoms
                                      });
                          })
                      })
                }), React.createElement(RenderIf$OrcaPaymentPage.make, {
                  condition: !isSavedCardFlow && (hasAnyField || isInfoElementPresent),
                  children: React.createElement(Surcharge$OrcaPaymentPage.make, {
                        paymentMethod: paymentMethod,
                        paymentMethodType: paymentMethodType
                      })
                }), React.createElement(RenderIf$OrcaPaymentPage.make, {
                  condition: isRenderInfoElement,
                  children: missingRequiredFieldsFiltered.length >= 1 ? bottomElement : React.createElement(Block$OrcaPaymentPage.make, {
                          bottomElement: Caml_option.some(bottomElement)
                        })
                }));
}

var make = DynamicFields;

export {
  DynamicFieldsToRenderWrapper ,
  FormBody ,
  make ,
}
/* jotai Not a pure module */
